import { useFormContext } from 'react-hook-form';
import { HookFormTextField } from '@upstart/commander-components';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
} from '@mui/material';
import React from 'react';
import { ShareDealDialogSendConfig } from './types';
import styles from './Content.module.scss';
import { FormSchema } from '../../schema';
import messages from '../../messages.json';

interface SendSectionProps {
  config: ShareDealDialogSendConfig;
  onChange: (newConfig: ShareDealDialogSendConfig) => void;
}

const SendSection: React.FC<SendSectionProps> = ({ config, onChange }) => {
  // use react-hook-form mainly for its validation on the email field
  const { control } = useFormContext<FormSchema>();
  const emitOnChange = (update: Partial<ShareDealDialogSendConfig>) => {
    onChange({ ...config, ...update });
  };
  return (
    <div
      className={`${styles.contentSection} ${styles.sendToSection}`}
      role="group"
      aria-label={messages.formStep.sendSectionAriaLabel}
    >
      <FormGroup>
        <FormControlLabel
          sx={{ mb: '7px' }}
          label={messages.formStep.smsCheckboxLabel}
          control={
            <Checkbox
              color="secondary"
              disabled={config.disablePhone}
              checked={config.shouldSendSms}
              onChange={(e) => {
                emitOnChange({ shouldSendSms: e.target.checked });
              }}
            />
          }
        />
        <TextField
          autoComplete="off"
          type="tel"
          label={messages.formStep.smsInputLabel}
          variant="outlined"
          disabled={config.disablePhone || config.disablePhoneInput}
          value={config.phone}
          inputProps={{
            'data-dd-privacy': 'mask',
          }}
          onChange={(e) => {
            emitOnChange({ phone: e.target.value });
          }}
        />
      </FormGroup>
      <FormGroup>
        <FormControlLabel
          sx={{ mb: '7px' }}
          label={messages.formStep.emailCheckboxLabel}
          control={
            <Checkbox
              color="secondary"
              checked={config.shouldSendEmail}
              onChange={(e) => {
                emitOnChange({ shouldSendEmail: e.target.checked });
              }}
            />
          }
        />
        <HookFormTextField
          control={control}
          name="email"
          autoComplete="off"
          type="email"
          label={messages.formStep.emailInputLabel}
          variant="outlined"
          onChange={(e) => emitOnChange({ email: e.target.value })}
          inputProps={{
            'data-dd-privacy': 'mask',
          }}
        />
      </FormGroup>
    </div>
  );
};

export default SendSection;
